import { defineComponent as _defineComponent } from 'vue'
import OzBox, { OzBoxColors } from '@@/library/v4/components/OzBox.vue'
import OzDivider, { OzDividerColorScheme } from '@@/library/v4/components/OzDivider.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BillingCollectionItems',
  props: {
    items: null
  },
  setup(__props: any) {



return { __sfc: true,OzBox, OzBoxColors, OzDivider, OzDividerColorScheme }
}

})